<template>
  <div class="index">
    <!-- 筛选 -->
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="160px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1_article"/>
          </div>
          <!-- <div>
            <el-form-item>
              <el-button type="primary" @click="filterClickNews()" icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div> -->
        </div>
      </el-form>
    </div>
    <!-- 编辑信息 -->
    <div class="editFormbox">
      <p>文章信息</p>
      <el-form label-width="120px" :rules="rules" ref="editForm" size="mini" :model="editForm">
        <el-form-item label="公司所在区域：">
          <el-input v-model="editForm.areaName" disabled></el-input>
        </el-form-item>
        <el-form-item label="文章标题：">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="文章简介：">
          <el-input v-model="editForm.description"></el-input>
        </el-form-item>
        <el-form-item label="主要内容：" prop="content">
          <editor-bar v-model="editForm.content"></editor-bar>
        </el-form-item>
        <div class="buttonbox">
          <el-button @click="rvoke()">撤销修改</el-button>
          <el-button type="primary" @click="submitNews()">保&emsp;存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import mixins from '@/Mixins/mixin_3g48.js'
import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
import EditorBar from '@/components/wangEditor'
export default {
  mixins:[mixins],
  components: {EditorBar},
  data() {
    return {
      rules:{//验证表单规则
        content: [
          { required: true, message: '请输入文章主体内容', trigger: 'blur' },
        ],
      },
      filterForm:{
        catalog:"briefIntroduction"
      },
      editForm:{//根据请求对象不同，会发生改变
        catalog:"briefIntroduction"
      },
      defaultEditForm:{//方便将editForm直接还原
        catalog:"briefIntroduction"
      },
      tableData:{},//请求得到的数据
    }
  },
  methods: {
    async getPlace1_article(data) {
      await this.getPlace1(data)
      this.filterClickNews()
    }
  },
  created() {
    this.getArea({ value: { areaId: 0 }, key: 0 });
    this.firstGetNews();
  },
}
</script>

<style lang='scss' scoped>
.editFormbox{width: 80%;margin: 20px auto;padding: 15px;border: 1px solid #ccc;border-radius: 1%;}
.editFormbox p{margin-bottom: 20px;text-align: center;font-weight: 400;color: #666;font-size: 20px;}
.el-form-item__label{font-size: 16px;}
.buttonbox{text-align: center;}
</style>